import * as React from 'react';
// import * as ReactDOM from 'react-dom';
import Editor from 'react-umeditor'
import config from '@/server/config';
import './index.scss'
import './mathquill.css'


export default class Umeditor extends React.Component<any, any>  {
    constructor(props: any){
        super(props);
        this.state = {
            content: "",
        }
    }
    handleChange(content?: any){
        this.setState({
            content: content
        })

        if(this.props.change) {
            this.props.change(content)
        }
    }
    getIcons(){
        var icons = [
            //"source | undo redo | bold italic underline strikethrough fontborder emphasis | ",
            //"paragraph fontfamily fontsize | superscript subscript | ",
            //"forecolor backcolor | removeformat | insertorderedlist insertunorderedlist | selectall | ",
            //"cleardoc  | indent outdent | justifyleft justifycenter justifyright | touppercase tolowercase | ",
            //"horizontal date time  | image emotion spechars | inserttable"
            "fontfamily fontsize bold image"
        ]
        return icons;
    }
    getQiniuUploader(){
        return {
           /* url:'http://upload.qiniu.com',
            type:'qiniu',
            name:"file",
            request: "image_src",*/
            /*qiniu:{
                app:{
                    Bucket:"liuhong1happy",
                    AK:"l9vEBNTqrz7H03S-SC0qxNWmf0K8amqP6MeYHNni",
                    SK:"eizTTxuA0Kq1YSe2SRdOexJ-tjwGpRnzztsSrLKj"
                },
                domain:"http://o9sa2vijj.bkt.clouddn.com",
                genKey:function(options?: any){
                    return options.file.type +"-"+ options.file.size +"-"+ options.file.lastModifiedDate.valueOf() +"-"+ new Date().valueOf()+"-"+options.file.name;
                }
            }*/
            "name":"file", 
            "url": "/api/upload" 
        }
    }
    render(){
        var icons = this.getIcons();
        var uploader = this.getQiniuUploader();

        console.log(uploader)
        var plugins = {
            image:{
                "uploader": {
                    name: "file",
                    url: `${config.API}image/upload/crmAnnex`,
                    data: {},
                    filter: (res: any)=> {

                        if(res.code === 1) {
                            const url = config.API + 'image/download/crmAnnex' + `?imgId=${res.obj}`;
                            return  url
                        }

                        return res
                        console.log( res , 'res.url')
                        
                    }
                  }
            }
        }
        var count = 100;
        var editors = [];
        for(var i=0;i<count;i++){
            editors.push({
                icons:icons,
                plugins:plugins
            })
        }
        return (
            <Editor ref="editor"
                icons={icons}
                value={this.state.content}
                defaultValue={this.props.defaultValue}
                onChange={this.handleChange.bind(this)}
                plugins={plugins} />
        )
    }
}